<template>
  <nuxt-link
    v-slot="{ isActive, isExactActive, href, navigate }"
    :to="computedTo"
    :active-class="activeClass"
    custom
  >
    <a
      v-bind="$attrs"
      :href="href"
      :class="(exact ? isExactActive : isActive) ? activeClass : inactiveClass"
      :aria-current="
        (exact ? isExactActive : isActive) && ariaCurrent
          ? ariaCurrent
          : undefined
      "
      @click="navigate"
    >
      <slot
        v-bind="{ isActive: exact ? isExactActive : isActive, href, navigate }"
      />
    </a>
  </nuxt-link>
</template>

<script lang="ts" setup>
import type { Rollout } from '@/types';
import type { NavigationItem } from '~~/composables/routing';

const props = defineProps({
  to: {
    type: String,
    default: '',
  },
  navigationItem: {
    type: Object as PropType<NavigationItem>,
    default: null,
  },
  global: {
    type: Boolean,
    default: false,
  },
  activeClass: {
    type: String,
  },
  inactiveClass: {
    type: String,
  },
  exact: {
    type: Boolean,
  },
  ariaCurrent: {
    type: String as () => 'page',
  },
});

const { selectedRollout } = useRolloutRouting();

const computedTo = computed(() => {
  if (props.navigationItem) {
    if (props.navigationItem.global) {
      return props.navigationItem.href;
    } else {
      if (!props.navigationItem.name.includes(':rolloutIdentifier()')) {
        return { name: props.navigationItem.name };
      }

      return {
        name: props.navigationItem.name,
        params: {
          rolloutIdentifier: (selectedRollout.value as Rollout).identifier,
        },
      };
    }
  } else if (!props.global) {
    return props.to.replace(
      ':rolloutIdentifier()',
      (selectedRollout.value as Rollout).identifier || ''
    );
  }
  return props.to;
});
</script>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>
